<template>
  <section class="tu-construye-checklist" aria-labelledby="tu-construye-checklist-title">
    <h2 id="tu-construye-checklist-title" class="tu-construye-checklist__title">
      Lo que necesitarás tener a la mano
    </h2>

    <ul class="tu-construye-checklist__grid">
      <li v-for="documento in documentos" :key="documento" class="tu-construye-checklist__item">
        <img :src="checkIcon" alt="" class="tu-construye-checklist__icon" aria-hidden="true">
        <DsText as="body3">{{ documento }}</DsText>
      </li>
    </ul>

    <h2 class="tu-construye-checklist__title">Recuerda que no aceptamos</h2>

    <ul class="tu-construye-checklist__exclusions">
      <li v-for="exclusion in exclusiones" :key="exclusion.title" class="tu-construye-checklist__item">
        <img :src="closeIcon" alt="" class="tu-construye-checklist__icon" aria-hidden="true">
        <span class="tu-construye-checklist__labels">
          <DsText as="body3">{{ exclusion.title }}</DsText>
          <DsText v-if="exclusion.detail" as="body4" class="tu-construye-checklist__detail">
            {{ exclusion.detail }}
          </DsText>
        </span>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import checkIcon from '../../../assets/tu-construye/ic_check.svg'
import closeIcon from '../../../assets/tu-construye/ic_close.svg'
import DsText from '../atoms/DsText.vue'

const documentos = [
  'Escrituras',
  'Boleta predial',
  'Recibo de agua',
  'Identificación oficial',
  'Comprobantes',
  'Avalúo del terreno',
  'Licencia de Construcción',
  'Presupuesto de obra'
]

const exclusiones = [
  { title: 'Remodelaciones', detail: '' },
  {
    title: 'Terrenos irregulares',
    detail: '(que no cumplan con las políticas de urbanización.)'
  }
]
</script>

<style scoped>
.tu-construye-checklist {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  padding: 24px 32px;
  border-radius: 16px;
  background: var(--ds-grey-50);
}

.tu-construye-checklist__title {
  margin: 0;
  font-family: var(--ds-font-family-bebas);
  font-size: 40px;
  font-weight: 700;
  line-height: 44px;
  color: var(--ds-purple-900);
}

.tu-construye-checklist__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.tu-construye-checklist__exclusions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.tu-construye-checklist__item {
  display: flex;
  align-items: center;
  gap: 16px;
}

.tu-construye-checklist__icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}

.tu-construye-checklist__labels {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.tu-construye-checklist__detail {
  color: var(--ds-text-primary);
}

@media (max-width: 1024px) {
  .tu-construye-checklist__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .tu-construye-checklist {
    padding: 24px;
  }

  .tu-construye-checklist__grid,
  .tu-construye-checklist__exclusions {
    grid-template-columns: 1fr;
  }
}
</style>
